export const P0003605HysteresisRegulationRx = [
  { label: '10 mV', ref: 10 },
  { label: '20 mV', ref: 20 },
  { label: '30 mV', ref: 30 },
  { label: '40 mV', ref: 40 },
  { label: '50 mV', ref: 50 },
];
